module.exports = __webpack_public_path__ + "static/media/Eterno Modular Sofa Console_Stone.848daf52.png";